import { referralCodeActions } from '../slices/referralcode-slice';

export const setVisibility = (isVisible=false) => {
    return (dispatch) => {
        dispatch(referralCodeActions.setVisibility(isVisible));
    };
};
